import type {ApiRequestOptions} from './types';

export const DEFAULT_OPTIONS: ApiRequestOptions = {
  notify: false,
  withAuth: true,
  withVersion: true,
};

export const REPEAT_DELAY = 2000;

export const delayPromises = {};
